import React from "react";
import { ArrowLeft, Calendar } from "lucide-react";

export default function BlogPostHero({ post }) {
  return (
    <section className="w-full bg-[#FFFFFF] pt-6 pb-2">
      <div className="px-14  max-w-8xl">
        <div className="flex justify-center w-full gap-2 ">
         <a
          href="/blog"
          aria-label="Back to blog"
          className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-purple-100 text-[#7209B7] mb-4 hover:bg-purple-100 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </a>

          <div className="relative rounded-[28px] overflow-hidden aspect-[16/8] bg-slate-200 w-full justify-center items-center">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover"
          />

          <div className="absolute left-2 right-2 bottom-2 sm:left-6 sm:right-auto sm:bottom-6 flex items-center justify-between gap-1.5 sm:gap-3 bg-black/45 backdrop-blur-sm rounded-2xl sm:rounded-full px-2.5 py-2.5 sm:pl-1.5 sm:pr-4 sm:py-1.5">
            <div className="flex items-center gap-1.5 sm:gap-3 min-w-0">
              <img
                src={post.avatar}
                alt={post.author}
                className="w-8 h-8 sm:w-9 sm:h-9 rounded-full object-cover bg-slate-200 shrink-0"
              />
              <div className="leading-tight min-w-0">
                <p className="text-[13px] sm:text-sm font-semibold text-white whitespace-nowrap">
                  {post.author}
                </p>
                <p className="text-[10px] sm:text-xs text-white/80 whitespace-nowrap">
                  {post.authorRole}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-1 sm:gap-3 shrink-0">
              <span className="w-px h-7 sm:h-8 bg-white/30 sm:mx-1" />
              <div className="flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-xs text-white/85 whitespace-nowrap">
                <Calendar className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                {post.date}
              </div>
            </div>
          </div>
        </div>



        </div>



      </div>
    </section>
  );
}
